import { FC } from "react";
import NoImg from "./no-img.png";

interface ComponentProps {
  src?: string | null;
  alt?: string;
}

const SingleEntityImageViewer: FC<ComponentProps> = ({
  src = null,
  alt = "Image",
}) => {
  return (
    <div
      style={{
        width: "50%",
        height: "150px",
        borderRadius: "8px",
        backgroundColor: src ? "#D3E3E0" : "#f0f0f0", // Gray background when no image
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          style={{
            width: "100px",
            height: "90px",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      ) : (
        <img src={NoImg} width={82} height={82} alt="Savi" />
      )}
    </div>
  );
};

export default SingleEntityImageViewer;
